import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import { ContextInfo } from '../models/login.model';
import * as loginActions from './login.actions';

export const loginFeatureKey = 'login';

export interface State {
  err: HttpErrorResponse | null;
  contextInfo: ContextInfo | null;
  loading: boolean;
}

export const initialState: State = {
  err: null,
  contextInfo: null,
  loading: false,
};

export const loginReducer = createReducer(
  initialState,
  on(loginActions.loadUserRequest, (state) => ({
    ...state,
    loading: true,
  })),
  on(loginActions.loadUserSuccess, (state, { contextInfo }) => ({
    err: null,
    contextInfo,
    loading: false,
  })),
  on(loginActions.loadUserFail, (state, { err }) => ({
    err,
    contextInfo: null,
    loading: false,
  })),
  on(loginActions.logout, (state) => ({
    ...state,
    contextInfo: null,
    err: null,
    loading: false,
  }))
);
